// Pastille « Serveur » / « Poste de travail », partagée par les quatre tables qui
// listent des machines (tableau de bord, fiche client, recherche avancée) et par
// la table d'alertes.
//
// Les deux valeurs ne sont PAS symétriques visuellement, et c'est délibéré : on
// consulte ces écrans pour repérer les serveurs au milieu des postes, jamais
// l'inverse. Le serveur est donc coloré, le poste reste dans le gris du texte
// secondaire — sans quoi une liste à 95 % de postes serait un mur de pastilles.

import { Monitor, Server, Router } from 'lucide-react';
import { fmtMachineType, isServerMachine } from '../lib/format.jsx';

export function MachineTypeBadge({ machineType, platform }) {
  const serveur = isServerMachine(machineType);
  // Un routeur est enregistré comme « Server » côté base (pour l'alerte hors
  // ligne) mais s'affiche « Routeur » : le libellé « Serveur » serait faux.
  const routeur = platform === 'routeros';
  const Icon = routeur ? Router : serveur ? Server : Monitor;
  return (
    <span
      className={`inline-flex items-center gap-1 whitespace-nowrap rounded px-2 py-0.5 text-[10px] font-semibold ${
        serveur
          ? // Écrit en clair d'abord puis `dark:` (même convention que les
            // pastilles de Provisions.jsx) : violet-400 sur fond blanc n'a pas
            // assez de contraste en thème clair. Le gris du poste passe lui par
            // le token `text-muted`, déjà adapté aux deux thèmes.
            'bg-violet-100 text-violet-700 dark:bg-violet-500/15 dark:text-violet-300'
          : 'bg-slate-500/10 text-muted'
      }`}
    >
      <Icon size={11} strokeWidth={2} />
      {routeur ? 'Routeur' : fmtMachineType(machineType)}
    </span>
  );
}
